import script from "./InspectorHotspot.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorHotspot.vue?vue&type=script&setup=true&lang=js"

import "./InspectorHotspot.vue?vue&type=style&index=0&id=73a263eb&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a263eb"]])

export default __exports__